///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-submit-button')) {
      // When the dynamic state change form is submitted,
      // trigger a popup confirmation modal.
      document.querySelector('.js-submit-button').addEventListener('click', confirmStateChange);

      // When a state change action is selected from the dropdown toggle
      // button, update the submit button accordingly.
      document.querySelectorAll('.js-available-states').forEach(function(action) {
        action.addEventListener('click', updateStateSubmitButton);
      });
    } else if (document.querySelector('.decommission-submit')) {
      // When the decommission state change form is submitted,
      // trigger a popup confirmation modal.
      document.querySelector('.decommission-submit').addEventListener('click', confirmStateChange);
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constants
  //
  ///////////////////////////////////////////////////////////////////

  const buttonValues = {
    approve: {
      value: 'approve',
      title: 'Approve',
      innerText: 'Approve',
    },
    finalize: {
      value: 'finalize',
      title: 'Finalize',
      innerText: 'Finalize',
    },
    return_for_edit: {
      value: 'return_for_edit',
      title: 'Return for Edit',
      innerText: 'Return for Edit',
    },

    // States listed above are pertinent to state changes on admin section
    // records (Teaching Tools and Provider/Employee Eligibility Checklists)
    // as well as Process Reviews. The "decommision" state below is specific
    // to admin section records and not part of the Process Review lifecycle,
    // so just noting that as FYI for consideration on any future changes
    // to this constant.
    decommission: {
      value: 'decommission',
      title: 'Decommission',
      innerText: 'Decommission',
    }
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Fire popup confirmation message
  //               on submit
  //
  function confirmStateChange(e) {
    // get submitted state and format for confirm popup
    const target    = e.target,
          action    = target.innerText.toLowerCase(),
          modelName = target.dataset.modelName;

    // prevent form submission on confirmation cancel
    if (!window.confirm(`Are you sure you want to ${action} this ${modelName}?`)) {
      return e.preventDefault();
    }
  }

  ///////////////////////////////////////////////
  //
  // Description - Set submit button values
  //               according to dropdown selection
  //
  function updateStateSubmitButton(e) {
    // grab attribute values for updating submit button
    const target           = e.currentTarget,
          buttonAttributes = buttonValues[target.id],
          submitButton     = document.querySelector('#state-submit');

    // update submit button
    submitButton.value     = buttonAttributes['value'];
    submitButton.title     = buttonAttributes['title'];
    submitButton.innerText = buttonAttributes['innerText'];
  }
}());
